import { css } from "@emotion/react";
import SyncIcon from "@mui/icons-material/Sync";
import { Box, useTheme } from "@mui/material";

export const LoadingSpinner = ({
  color,
  label,
}: {
  color?: string;
  label?: string;
}) => {
  const theme = useTheme();
  const styles = {
    animatedLoading: css`
      animation: spinner 2s linear infinite;

      @keyframes spinner {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `,
  };
  return (
    <Box
      data-testid="loading-spinner"
      sx={{
        display: "flex",
        gap: theme.spacing(1),
        color: color,
      }}
    >
      <SyncIcon css={styles.animatedLoading} htmlColor={color} />
      {label ? ` ${label}` : ""}
    </Box>
  );
};
